// Een blok dat eruit springt: een waarschuwing, een tip, iets om te onthouden.
//
// In een notitie over een klant is "let op: de pinautomaat hangt aan vlan 30" iets anders dan
// de rest van de tekst, en dat hoort ook zo te lezen. Drie soorten is genoeg; meer kleuren
// maken een notitie een verkeerslicht.
//
// In de export wordt het een citaat met een markering erboven (`> [!NOTE]`), precies de vorm
// die GitHub en steeds meer andere lezers begrijpen. Zo blijft het buiten deze app leesbaar.

import { Node, mergeAttributes } from "@tiptap/core";

export type CalloutSoort = "info" | "tip" | "waarschuwing";

export const CALLOUT_SOORTEN: { soort: CalloutSoort; label: string; teken: string; markering: string }[] = [
  { soort: "info", label: "Ter info", teken: "ℹ", markering: "NOTE" },
  { soort: "tip", label: "Tip", teken: "✓", markering: "TIP" },
  { soort: "waarschuwing", label: "Let op", teken: "!", markering: "WARNING" }
];

export const Callout = Node.create({
  name: "callout",
  group: "block",
  content: "block+",
  defining: true,

  addAttributes() {
    return {
      soort: {
        default: "info",
        parseHTML: (element) => element.getAttribute("data-soort") ?? "info",
        renderHTML: (attributes) => ({ "data-soort": attributes.soort })
      }
    };
  },

  parseHTML() {
    return [{ tag: "div[data-callout]" }];
  },

  renderHTML({ HTMLAttributes, node }) {
    const soort = String(node.attrs.soort ?? "info");
    const vorm = CALLOUT_SOORTEN.find((s) => s.soort === soort) ?? CALLOUT_SOORTEN[0];
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-callout": "1", class: `callout callout-${soort}` }),
      // Het tekentje staat in de opmaak en niet in de tekst: anders zou je het kunnen wissen
      // en blijft er een blok zonder kop over.
      ["div", { class: "calloutkop", contenteditable: "false" }, `${vorm.teken}  ${vorm.label}`],
      ["div", { class: "calloutinhoud" }, 0]
    ];
  },

  addCommands() {
    return {
      zetCallout:
        (soort: CalloutSoort) =>
        ({ commands }: { commands: any }) =>
          commands.wrapIn(this.name, { soort }),
      haalCalloutWeg:
        () =>
        ({ commands }: { commands: any }) =>
          commands.lift(this.name)
    } as any;
  }
});
